"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.zrxServiceFactory = void 0;
const identity_1 = __importDefault(require("lodash/identity"));
const types_1 = require("../../../types");
const utils_1 = require("../../../utils");
const maxAge = 5 * 1000; // 5 seconds
const cachedUrls = ['/swap/v1/price'];
const axiosConfig = {
    timeout: 10000,
};
const zrxServiceFactory = ({ baseUrl, wrapper = identity_1.default, }) => {
    const cache = (0, utils_1.createCache)(maxAge, cachedUrls, { ...axiosConfig, baseURL: baseUrl });
    const axiosInstance = wrapper(cache);
    return (0, utils_1.makeSwapperAxiosServiceMonadic)(axiosInstance, types_1.SwapperName.Zrx);
};
exports.zrxServiceFactory = zrxServiceFactory;
